"use strict";

/**
 * Copyright 2004-present Facebook. All Rights Reserved.
 */
module.exports = {
  overrides: {}
};